<osapp-header-modal title="Image déja dans le dossier patient"></osapp-header-modal>

<ion-content>
	<ion-grid fixed>
		<ion-row class="input-row">
			<osapp-selector displayMode="list" [options]="documentList" (selectionChanged)="onSelectImage($event)" limit="1">
			</osapp-selector>
		</ion-row>
	</ion-grid>
</ion-content>

<ion-fab vertical="bottom" horizontal="end" slot="fixed" class="fab-margin">
	<ion-fab-button color="success" (click)="close()" title="Valider">
		<ion-icon name="checkmark"></ion-icon>
	</ion-fab-button>
</ion-fab>